import * as React from 'react'
import { styled } from '../../../../shared/styled-components'
import { Utils } from '../../../../shared/Utils'

export const OverlayCloseButton = ({ ...args }) => {
  return <Icon {...args} src={Utils.getAssetPath('/assets/calculator/result/close-overlay.svg')} />
}

const Icon = styled.img`
  width: 3rem;
  height: 3rem;
  cursor: pointer;
`
